export default class Review {
  public courseId?: string = ''
  public enrollmentId?: string = ''
  public userId?: string = ''
  public body: string = ''
  public rank: number = 0

  toFormData() {
    const formData = new FormData()

    if (this.courseId) {
      formData.append('course_id', this.courseId)
    }
    if (this.body) {
      formData.append('body', this.body)
    }

    if (this.rank) {
      formData.append('rank', this.rank.toString())
    }

    if (this.enrollmentId) {
      formData.append('enrollment_id', this.enrollmentId)
    }

    return formData
  }
}
